import {
    InfoCircleOutlined,
    PlusCircleOutlined,
    RetweetOutlined
} from "@ant-design/icons";
import { Button, Card, Col, ConfigProvider, Divider, Flex, Form, List, Modal, Row, Space, Tooltip } from "antd";
import { useForm } from "antd/es/form/Form";
import { FormDatePicker, FormInput, FormInputNumber, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { ACTION } from "../schemas/PaymentShemas";
import { handleInputNumber } from "utils/helper/numberInput";
import { Option } from "antd/es/mentions";
import { Switch } from "antd/lib";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { ReactComponent as ResetIcon } from "../../../assets/icon/reset.svg";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { useSelector } from "react-redux";

function PaymentModal({
    isModalOpen = false,
    onCancel = () => { },
    onFinish = () => { },
    onBack = () => { },
    onResetList = () => { },
    previewEditIncomeDeduct = () => { },
    getOvertimeInPeriod = () => { },
    employee = {},
    incomeSetup = [],
    step = 0,
    action = "",
    handleIncomeDeductType = () => { },
    setEditingTax = () => { },
    currentTxnPayment = []
}) {
    const { t, i18n } = useTranslation();
    const [form] = useForm();
    const formItemLayout = {
        labelCol: { span: 8 }, // Adjust the span as needed
    };
    const [buttonType, setButtonType] = useState(action);
    const [sumIncome, setSumIncome] = useState(0);
    const [sumDeduct, setSumDeduct] = useState(0);
    const [netIncome, setNetIncome] = useState(0);
    const [switchOn, setSwitchOn] = useState(false);
    const [modifiedValue, setModifiedValue] = useState(false);
    const { isLoading } = useSelector((state) => state.payment)

    const [otState, setOtState] = useState([])

    const onSearchOt = (params) => {
        setOtState(params)
        if (params?.overtimeShiftDetails) {
            params?.overtimeShiftDetails?.forEach?.(o => {
                form.setFieldsValue({
                    [`${o.id}_ot_rate`]: o?.otMultiplyRate,
                    [`${o.id}_totalCal`]: o?.totalCal / 60,
                    [`${o.id}_ot_amount`]: o?.totalPaid,
                    [`${o.id}_ot_overtimeListIds`]: o?.overtimeListIds
                })
            })
        }
    }

    const tooltipsText = useCallback((expenseInfoList) => {
        if (expenseInfoList == null) {
            return null;
        }
        return <Row >
            {expenseInfoList?.map((o, i) => {
                const welfareName =
                    i18n.language === "en" ? o?.welfareNameEn : o?.welfareName
                const baht = i18n.language === "en" ? "Baht" : "บาท"
                const sq = o?.sequence + "|"
                return <><Col span={10}>
                    {sq}
                </Col>
                    <Col span={14}>
                        {welfareName} {o?.amount} {baht}
                    </Col></>
            })}
        </Row>
    }, [i18n])

    useMemo(() => {
        if (action === 'edit') {
            setButtonType(ACTION.EDIT)
        }
        if (action === 'view') {
            setButtonType(ACTION.VIEW)
        }
        setModifiedValue(false)

    }, [action, isModalOpen])

    const calculateAndFormatSum = (data) => {
        if (!data || !Array.isArray(data) || data?.length === 0) {
            return '0.00';
        }

        const sum = data.reduce((acc, item) => {
            const amountStr = item?.amount && typeof item?.amount === 'string' ? item?.amount?.replace(/,/g, '') : '0';
            const amount = parseFloat(amountStr);
            return acc + (isNaN(amount) ? 0 : amount);
        }, 0);

        return sum.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const calculateNetIncome = (incomes, deducts) => {
        // if (!incomes || !Array.isArray(incomes) || incomes?.length === 0) {
        //     return '0.00';
        // }

        const sumIncome = incomes?.reduce((acc, item) => {
            const amountStr = item?.amount && typeof item?.amount === 'string' ? item?.amount?.replace(/,/g, '') : '0';
            const amount = parseFloat(amountStr);
            return acc + (isNaN(amount) ? 0 : amount);
        }, 0);

        const sumDeduct = deducts?.reduce((acc, item) => {
            const amountStr = item?.amount && typeof item?.amount === 'string' ? item?.amount?.replace(/,/g, '') : '0';
            const amount = parseFloat(amountStr);
            return acc + (isNaN(amount) ? 0 : amount);
        }, 0);
        let sum = sumIncome - sumDeduct;
        return sum.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    };

    const filterAndMapItems = (obj) => Object.keys(obj)
        .filter(key => key !== 'incomeList' && key !== 'deductionList' && !key?.match(".*(ot_rate|ot_overtimeListIds|ot|totalCal|ot_amount|_unit)$"))
        .map(fullKey => {
            console.log("fullKey", fullKey, obj[fullKey], obj);
            const [incomeDeductionId, incomeDeductionType] = fullKey.split('_');
            if (!/[A-Z]/.test(incomeDeductionId)) {
                const type = incomeDeductionType?.startsWith('D') ? 'Deduction' : 'Income';
                return {
                    incomeDeductionId,
                    amount: obj[fullKey],
                    unit: obj[fullKey + "_unit"],
                    type,
                    code: incomeDeductionType,
                };
            }
            return null;
        })
        .filter(item => item !== null);

    const groupByType = (items) => items.reduce((acc, item) => {
        const groupName = item?.type === 'Income' ? 'incomeList' : 'deductionList';
        acc[groupName] = acc[groupName] || [];
        acc[groupName].push(item);
        return acc;
    }, {});

    const groupBy = (input, key) => {
        return input.reduce((acc, currentValue) => {
            let groupKey = currentValue[key];
            if (!acc[groupKey]) {
                acc[groupKey] = [];
            }
            acc[groupKey].push(currentValue);
            return acc;
        }, {});
    };

    let modifiedForSubmit = (obj) => {
        const modifiedReq = filterAndMapItems(obj)
        const groupedByType = groupByType(modifiedReq);
        // Object.keys(obj).
        console.log("modifiedReq", modifiedReq, groupedByType);

        let ot = []
        if (switchOn) {
            ot = Object.keys(obj).filter(o => o.match(".*_ot$") && form.getFieldValue(o) != null).map(o => {
                console.log("oooo", o.replace("_ot", ""));
                let id = o.replace("_ot", "");
                return {
                    incomeDeductionId: form.getFieldValue(o),
                    unit: form.getFieldValue([`${id}_totalCal`]),
                    type: 'Income',
                    ot: 'Y',
                    amount: form.getFieldValue([`${id}_ot_amount`]),
                    overtimeListIds: form.getFieldValue([`${id}_ot_overtimeListIds`]),
                }
            })
            let otGroup = groupBy(ot, 'incomeDeductionId');
            // console.log("otGroup", );
            Object.keys(otGroup).forEach(o => {
                console.log("otGroup2", o, otGroup[o]);
                let list = otGroup[o];
                console.log("list", list.filter(o => o.overtimeListIds).map(o => o.overtimeListIds).join(",").split(","));

                let group = groupedByType.incomeList.find(o1 => o1.incomeDeductionId == o)
                if (!group) {
                    groupedByType.incomeList.push({
                        ...list?.[0],
                        ot: 'Y',
                        amount: list?.reduce((o1, o2) => o1 + o2.amount, 0),
                        unit: list?.reduce((o1, o2) => o1 + (o2.unit ? o2.unit : 0), 0)
                    })
                } else {
                    groupedByType.incomeList = groupedByType.incomeList.map(check => {
                        if (check.incomeDeductionId == o) {
                            return {
                                ...check,
                                overtimeListIds: list?.filter?.(o => o.overtimeListIds)?.map?.(o => o.overtimeListIds)?.join?.(",")?.split?.(","),
                                ot: 'Y',
                                amount: list?.reduce((o1, o2) => o1 + Number(o2.amount), 0),
                                unit: list?.reduce((o1, o2) => o1 + Number(o2.unit ? o2.unit : 0), 0)
                            }
                        } else {
                            return check
                        }
                    })
                }
            })
        }
        console.log("groupedByType", groupedByType);

        return {
            ...groupedByType,
        };
    }

    useEffect(() => {
        const newSumIncome = employee?.incomeList ? calculateAndFormatSum(employee?.incomeList) : 0;
        setSumIncome(newSumIncome);

        const newSumDeduct = employee?.deductionList ? calculateAndFormatSum(employee?.deductionList) : 0;
        setSumDeduct(newSumDeduct);

        const sum = calculateNetIncome(employee?.incomeList, employee?.deductionList)
        setNetIncome(sum)
    }, [employee]);

    useMemo(() => {
        // form.resetFields()
        console.log("employee", employee, form.getFieldsValue(true));
        employee?.incomeList?.forEach(o => {
            let str = `${o?.id}`;
            form.setFieldValue(str, String(o?.amount)?.replace(",", ""));
            let strUnit = `${o?.id}_unit`;
            form.setFieldValue(strUnit, String(o?.unit ? o?.unit : 0)?.replace(",", ""));
        });
        employee?.deductionList?.forEach(o => {
            let str = `${o?.id}`;
            form.setFieldValue(str, String(o?.amount)?.replace(",", "") || 0);
        });

    }, [form, employee?.incomeList, employee?.deductionList]);

    const onCancelFininsh = () => {
        setSwitchOn(false)
        setOtState([])
        setModifiedValue(false)
        // setButtonType(ACTION.PREVIEW)
        form.resetFields()
    }

    return (
        <>
            {/* {employmentIncomeDeductTypeModal()} */}
            <Modal
                closable={false}
                maskClosable={false}
                zIndex={1000}
                width="85vw"
                footer={() => {
                    return (
                        <>
                            <Row justify={'center'}>
                                {buttonType === ACTION.PREVIEW && (
                                    <Button
                                        onClick={() => {
                                            onBack();
                                            setButtonType(ACTION.EDIT);
                                        }}
                                        type="default"
                                        style={{ borderRadius: "8px", height: "40px", fontWeight: "bold" }}
                                    >
                                        {t("common.back")}
                                    </Button>
                                )}
                                <Space direction="horizontal" size={10}>
                                    <Button
                                        onClick={() => {
                                            onCancel();
                                            setButtonType(action);
                                            form.resetFields()
                                            setEditingTax("N")
                                            setSwitchOn(false)
                                            setOtState([])
                                        }}
                                        type="default"
                                        style={{ borderRadius: "8px", height: "40px", fontWeight: "bold" }}
                                    >
                                        {t("common.cancel")}
                                    </Button>
                                    {
                                        action === 'view' ? null : (
                                            !modifiedValue ?
                                                <Tooltip title="ปุ่มนี้จะไม่สามารถกดได้จนกว่าจะกดปุ่ม คำนวณใหม่">
                                                    <Button
                                                        disabled={!modifiedValue}
                                                        onClick={() => {
                                                            form.submit();
                                                            setButtonType(ACTION.EDIT);
                                                            // setSwitchOn(false)
                                                        }}
                                                        type="primary"
                                                        style={{
                                                            backgroundColor: "#2CADE7",
                                                            borderRadius: "8px",
                                                            boxShadow: "none",
                                                            fontWeight: "bold",
                                                            height: "40px"
                                                        }}
                                                    >
                                                        {t("common.submit")}
                                                    </Button>
                                                </Tooltip>
                                                :
                                                <Button
                                                    disabled={!modifiedValue}
                                                    onClick={() => {
                                                        form.submit();
                                                        setButtonType(ACTION.EDIT);
                                                        // setSwitchOn(false)
                                                    }}
                                                    type="primary"
                                                    style={{
                                                        backgroundColor: "#2CADE7",
                                                        borderRadius: "8px",
                                                        boxShadow: "none",
                                                        fontWeight: "bold",
                                                        height: "40px"
                                                    }}
                                                >
                                                    {t("common.submit")}
                                                </Button>
                                        )}
                                </Space>
                            </Row>
                        </>

                    )
                }
                }
                destroyOnClose={true}
                title={
                    <Flex justify={"space-between"} align="center" size={20}>
                        <Flex gap={16}>
                            {`${t('edit.income.deduction')}`}
                            <span style={{ color: "#42526D" }}>
                                {`${currentTxnPayment?.employeeNo} : ${i18n.language == "en" ? currentTxnPayment?.nameEn : currentTxnPayment?.name} ${i18n.language == "en" ? currentTxnPayment?.surNameEn : currentTxnPayment?.surName}`}</span>
                        </Flex>
                        <Space size={12}>
                            <Button
                                type="primary"
                                style={{ display: action != 'edit' ? "none" : "inline", height: "40px", borderRadius: "8px", backgroundColor: "#FFA500", fontWeight: "bold", boxShadow: "none" }}
                                onClick={onResetList}>
                                {t("appearance.label.reset")}
                            </Button>
                            <Button
                                loading={isLoading}
                                type="primary"
                                style={{ display: action != 'edit' ? "none" : "inline", height: "40px", borderRadius: "8px", backgroundColor: "#2CADE7", boxShadow: "none" }}
                                onClick={() => {
                                    let modifiedValue = modifiedForSubmit({
                                        ...form.getFieldsValue(true),
                                    })
                                    console.log("modifiedValue2", modifiedValue);
                                    previewEditIncomeDeduct({
                                        ...modifiedValue,
                                        salary: form.getFieldsValue()?.salary,

                                    })
                                    form.setFieldValue("overtimeRequestId", otState.overtimeRequestId)
                                    setModifiedValue(true)
                                }}
                            >
                                {!isLoading ?
                                    <Flex gap={8} style={{ alignItems: "center" }}>
                                        <ResetIcon />
                                        คำนวนใหม่
                                    </Flex>
                                    : <span>คำนวนใหม่</span>
                                }
                            </Button>
                        </Space>
                    </Flex>}
                open={isModalOpen}
            >
                <FormAntd
                    {...formItemLayout}
                    colon={false}
                    form={form}
                    onFinish={(val) => {
                        console.log("val", val);
                        let modifiedValue = modifiedForSubmit({
                            ...val,
                        })
                        console.log("modifiedValuemodifiedValue", modifiedValue);
                        onFinish({
                            ...modifiedValue,
                            salary: val?.salary,
                            overtimeRequestId: modifiedValue?.incomeList?.filter(o => o.overtimeListIds)?.map(o => o.overtimeListIds)?.join(",")?.split(",").filter(o => o != '')
                        }, onCancelFininsh)
                    }}
                    initialValues={{
                        // * initial values
                        // ...employeeModal
                    }}

                    requiredMark={(label, { required }) => {
                        if (required) {
                            return (
                                <Flex>
                                    {label}
                                    {<span style={{ color: "red" }}>*</span>}
                                </Flex>)
                        } else {
                            return label
                        }
                    }
                    }
                >
                    <Form.Item shouldUpdate={(prev, curv) => {
                        //  prev['startDate'] != curv['startDate']
                        return true
                    }}  {...formItemLayout}>
                        {({ getFieldsValue, getFieldValue, setFieldValue }) => {
                            return (
                                <Flex vertical>
                                    <Row style={{ width: "100%" }}>
                                        <Col span={12} style={{ borderRight: "1px solid #F0F0F0" }}>
                                            <Space direction="vertical">
                                                <Card title={
                                                    <Flex justify="space-between" align="center">
                                                        <label>{t('payment.label.income')}</label>
                                                        {buttonType === ACTION.EDIT &&
                                                            <Button
                                                                onClick={() => handleIncomeDeductType("income")}
                                                                icon={<CreateIcon />}
                                                                style={{ height: "33px", width: "33px", borderRadius: "8px" }}
                                                            />
                                                        }
                                                    </Flex>}
                                                    style={{ width: "40vw" }}>
                                                    <div style={{ maxHeight: '40vh', overflowY: 'scroll' }}>
                                                        <Row gutter={12}>
                                                            <Col span={12}>
                                                            </Col>
                                                            <Col span={4} style={{ textAlign: "center" }}>
                                                                <span style={{ color: "#667085" }}>{t("common.unit")}</span>
                                                            </Col>
                                                            <Col span={8} style={{ textAlign: "center" }}>
                                                                <span style={{ color: "#667085" }}>{t("dashboard.label.amount")}</span>
                                                            </Col>
                                                        </Row>
                                                        <List
                                                            dataSource={employee?.incomeList}
                                                            renderItem={(item) => (
                                                                <List.Item style={{ display: "block" }}>
                                                                    {/* <Flex gap={5} justify="space-between" style={{ textAlign: "center" }}> */}
                                                                    <Row gutter={12} style={{ width: "100%" }}>
                                                                        <Col span={12}>
                                                                            <Flex justify="space-between">
                                                                                <span style={{ color: "#667085" }}>
                                                                                    {item?.income?.code == "I01" ?
                                                                                        i18n.language === "en" ? item?.income?.nameEn + ` ( ${item?.incomeType?.incomeNameEn}) ${((item?.deductionWithholdingTax || '') + (item?.deductionWithholdingTax ? "%" : ''))}` : item?.income?.name + ` ( ${item?.incomeType?.incomeName} ${((item?.deductionWithholdingTax || '') + (item?.deductionWithholdingTax ? "%" : ''))} )`
                                                                                        : i18n.language === "en" ? item?.income?.nameEn : item?.income?.name}</span>

                                                                            </Flex>
                                                                        </Col>
                                                                        <Col span={4}>
                                                                            <FormInputNumber
                                                                                controls={false}
                                                                                textAlign={'right'}
                                                                                disabled={buttonType === ACTION.PREVIEW ? true : step > 0
                                                                                    // || item?.income?.code === 'I01'
                                                                                    || action == 'view'}
                                                                                name={`${item?.id}_unit`}
                                                                                // onChange={(value) => {
                                                                                //     handleInputNumber(value, setFieldValue, `${item?.income?.id}_${item?.income?.code}`)
                                                                                // }}
                                                                                required
                                                                                min={0.00}
                                                                            />
                                                                        </Col>
                                                                        <Col span={7}>
                                                                            <Flex>
                                                                                <FormInputNumber
                                                                                    controls={false}
                                                                                    textAlign={'right'}
                                                                                    disabled={buttonType === ACTION.PREVIEW ? true : step > 0
                                                                                        // || item?.income?.code === 'I01'
                                                                                        || action == 'view'}
                                                                                    name={`${item?.id}`}
                                                                                    onChange={(value) => {
                                                                                        // handleInputNumber(value, setFieldValue, `${item?.income?.id}_${item?.income?.code}`)
                                                                                        setModifiedValue(false)
                                                                                    }}
                                                                                    required
                                                                                    min={0.00} />


                                                                            </Flex>
                                                                        </Col>
                                                                        <Col span={1}>
                                                                            {tooltipsText(item?.expenseInfo)
                                                                                ? (
                                                                                    <Tooltip
                                                                                        // title={
                                                                                        //     <div
                                                                                        //         style={{
                                                                                        //             color: '#000',
                                                                                        //             // width: '40vw',
                                                                                        //             width: '100%',
                                                                                        //         }}
                                                                                        //     >
                                                                                        //         {tooltipsText(item?.expenseInfo)}
                                                                                        //     </div>
                                                                                        // }
                                                                                        color="#fff"
                                                                                        key="#0000"
                                                                                        overlay={<Card styles={{
                                                                                            body: {
                                                                                                // width: "500px",
                                                                                                padding: 0,
                                                                                            }
                                                                                        }} >{tooltipsText(item?.expenseInfo)}</Card>}
                                                                                        placement='right'
                                                                                        overlayInnerStyle={{ color: '#000', backgroundColor: '#fff' }}
                                                                                    >
                                                                                        <InfoCircleOutlined />
                                                                                    </Tooltip>
                                                                                )
                                                                                : null
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                </List.Item>
                                                            )} />
                                                    </div>
                                                    {buttonType === ACTION.PREVIEW && (
                                                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                            {`${t("employee.total_income")} ${sumIncome}`}
                                                        </div>
                                                    )}
                                                </Card>
                                            </Space>
                                        </Col>

                                        {/* <Col span={1} style={{ borderRight: "2px solid" }}></Col> */}
                                        <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Space direction="vertical">
                                                <Card title={<Flex justify="space-between" align="center">
                                                    <label>{t('payment.label.deduction')}</label>
                                                    {buttonType === ACTION.EDIT &&
                                                        <Button
                                                            onClick={() => handleIncomeDeductType("deduct")}
                                                            icon={<CreateIcon />}
                                                            style={{ height: "33px", width: "33px", borderRadius: "8px" }}
                                                        />
                                                    }
                                                </Flex>} style={{ width: "40vw" }}>
                                                    <div style={{ maxHeight: '40vh', overflowY: 'scroll' }}>
                                                        <Row gutter={12}>
                                                            <Col span={12}>
                                                            </Col>
                                                            <Col span={8} style={{ textAlign: "center" }}>
                                                                <span style={{ color: "#667085" }}>{t("dashboard.label.amount")}</span>
                                                            </Col>
                                                            <Col span={4}>
                                                            </Col>
                                                        </Row>
                                                        <List
                                                            dataSource={employee?.deductionList}
                                                            renderItem={(item) => (
                                                                <List.Item style={{ display: "block" }}>
                                                                    <Row>
                                                                        <Col span={20}>
                                                                            <Flex justify="space-between">
                                                                                <span style={{ color: "#667085" }}>{i18n.language === 'en' ? item?.deduction?.nameEn : item?.deduction?.name}</span>
                                                                                <FormInputNumber
                                                                                    textAlign={'right'}
                                                                                    disabled={(buttonType === ACTION.PREVIEW ? true : step > 0)
                                                                                        || action == 'view'}
                                                                                    name={`${item?.id}`}
                                                                                    controls={false}
                                                                                    required
                                                                                    min={0.00}
                                                                                    onChange={(e) => {
                                                                                        console.log("item", item);
                                                                                        item.modified = "Y";
                                                                                        setModifiedValue(false)
                                                                                    }} />
                                                                            </Flex>
                                                                        </Col>
                                                                        <Col span={1}></Col>
                                                                        <Col span={3}>
                                                                            {tooltipsText(item?.expenseInfo)
                                                                                ? (
                                                                                    <Tooltip
                                                                                        // title={
                                                                                        //     <div
                                                                                        //         style={{
                                                                                        //             color: '#000',
                                                                                        //             // width: '40vw',
                                                                                        //             width: '100%',
                                                                                        //         }}
                                                                                        //     >
                                                                                        //         {tooltipsText(item?.expenseInfo)}
                                                                                        //     </div>
                                                                                        // }
                                                                                        color="#fff"
                                                                                        key="#0000"
                                                                                        overlay={<Card styles={{
                                                                                            body: {
                                                                                                // width: "500px",
                                                                                                padding: 0,
                                                                                            }
                                                                                        }} >{tooltipsText(item?.expenseInfo)}</Card>}
                                                                                        placement='right'
                                                                                        overlayInnerStyle={{ color: '#000', backgroundColor: '#fff' }}
                                                                                    >
                                                                                        <InfoCircleOutlined />
                                                                                    </Tooltip>
                                                                                )
                                                                                : null
                                                                            }
                                                                        </Col>
                                                                    </Row>

                                                                </List.Item>
                                                            )} />
                                                    </div>
                                                </Card>
                                            </Space>
                                        </Col>
                                    </Row>
                                    {action === 'edit' ?
                                        <Space style={{ marginTop: 20 }}>
                                            <span>
                                                คำนวณ OT อัตโนมัติ
                                            </span>
                                            <Switch
                                                checked={switchOn}
                                                onChange={(checked) => setSwitchOn(checked)}
                                            />
                                        </Space> : null}
                                    {switchOn &&
                                        <Row style={{ width: "100%" }}>
                                            <Col span={12} style={{ borderRight: "1px solid #F0F0F0" }} >
                                                <Space direction="vertical">
                                                    <Card title={
                                                        <Flex justify="space-between" align="center">
                                                            <label>ค่าทำงานล่วงเวลา</label>
                                                            <Button type="primary" style={{ display: action != 'edit' ? "none" : "inline", height: "40px", borderRadius: "8px", backgroundColor: "#FFA500", fontWeight: "bold", boxShadow: "none" }}
                                                                onClick={() => {
                                                                    otState?.overtimeShiftDetails?.forEach?.(o => {
                                                                        console.log("ot ", o, (o?.totalCal / 60) * (otState?.basePerHour * o?.otMultiplyRate))
                                                                        form.setFieldsValue({
                                                                            [`${o.id}_ot_rate`]: o?.otMultiplyRate,
                                                                            [`${o.id}_totalCal`]: o?.totalCal / 60,
                                                                            [`${o.id}_ot_amount`]: o?.totalPaid,
                                                                            [`${o.id}_ot_overtimeListIds`]: o?.overtimeListIds
                                                                        })
                                                                    })
                                                                }} >
                                                                {t("appearance.label.reset")}
                                                            </Button>
                                                        </Flex>} style={{ width: "40vw" }}>
                                                        <div style={{ overflowY: 'scroll' }}>
                                                            <span style={{ color: "#42526D" }}>{t("start-date-to-end-date")}</span>
                                                            <Flex gap={5}>
                                                                <FormDatePicker name="dateRangeOt" type="range"></FormDatePicker>
                                                                <Button onClick={() => {
                                                                    getOvertimeInPeriod({ date: getFieldValue('dateRangeOt'), fn: onSearchOt })
                                                                }}
                                                                    type="primary"
                                                                    style={{ backgroundColor: "#2CADE7", fontWeight: "bold" }}
                                                                >
                                                                    {t("common.search")}
                                                                </Button>
                                                            </Flex>
                                                            <Flex vertical style={{ marginTop: "16px" }}>
                                                                <Row gutter={12}>
                                                                    <Col span={9}>
                                                                    </Col>
                                                                    <Col span={5} style={{ textAlign: "center" }}>
                                                                        <span style={{ color: "#667085" }}>{t("employmentType.label.times")}</span>
                                                                    </Col>
                                                                    <Col span={5} style={{ textAlign: "center" }}>
                                                                        <span style={{ color: "#667085" }}>{t("leave_type.label.leave-hour")}</span>
                                                                    </Col>
                                                                    <Col span={5} style={{ textAlign: "center" }}>
                                                                        <span style={{ color: "#667085" }}>{t("dashboard.label.amount")}</span>
                                                                    </Col>
                                                                </Row>
                                                                <List
                                                                    dataSource={otState?.overtimeShiftDetails}
                                                                    renderItem={(item) => (
                                                                        <List.Item style={{ display: "block" }}>
                                                                            {/* <Flex gap={5} justify="space-between" style={{ textAlign: "center" }}> */}
                                                                            <Row gutter={12}>
                                                                                <Col span={9}>
                                                                                    <FormSelect
                                                                                        allowClear
                                                                                        placeholder={"กรุณาเลือก"} name={`${item?.id}_ot`} options={incomeSetup?.filter?.(o => o?.income?.overTime == 'Y').map(o =>
                                                                                        ({
                                                                                            label: i18n.language === "en" ? o?.income?.nameEn : o?.income?.name,
                                                                                            value: o?.id
                                                                                        })
                                                                                        )}>
                                                                                    </FormSelect>
                                                                                </Col>
                                                                                <Col span={5}>
                                                                                    <FormInputNumber
                                                                                        textAlign={'right'}
                                                                                        name={`${item?.id}_ot_rate`}
                                                                                        controls={false}
                                                                                        disabled
                                                                                        required
                                                                                        min={0.00} />
                                                                                </Col>
                                                                                <Col span={5}>
                                                                                    <FormInputNumber
                                                                                        textAlign={'right'}
                                                                                        controls={false}
                                                                                        name={`${item?.id}_totalCal`}
                                                                                        onChange={(e) => {
                                                                                            console.log("e", e);
                                                                                            setFieldValue(`${item?.id}_ot_amount`, e * getFieldValue(`${item?.id}_ot_rate`) * otState?.basePerHour)
                                                                                        }}
                                                                                        required
                                                                                        min={0.00} />
                                                                                </Col>
                                                                                <Col span={5}>
                                                                                    <FormInputNumber
                                                                                        textAlign={'right'}
                                                                                        controls={false}
                                                                                        disabled
                                                                                        name={`${item?.id}_ot_amount`}
                                                                                        required
                                                                                        min={0.00} />
                                                                                </Col>
                                                                            </Row>
                                                                        </List.Item>
                                                                    )} />
                                                                <Row>
                                                                    <Col span={9} style={{ textAlign: 'right', paddingRight: 15 }}><span style={{ color: "#667085" }}>รวมค่าล่วงเวลา</span></Col>
                                                                    <Col span={5} style={{ textAlign: 'right' }}><span></span></Col>
                                                                    <Col span={5} style={{ textAlign: 'right', paddingRight: 15 }} ><span >{get2DecimalPointsWithCommas(Object.keys(getFieldsValue(true)).filter(o => o.match(".*_totalCal$")).map(o => getFieldValue(o)).reduce((sum, o) => sum + Number(o), 0.00))}</span></Col>
                                                                    <Col span={5} style={{ textAlign: 'right', paddingRight: 15 }}><span >{get2DecimalPointsWithCommas(Object.keys(getFieldsValue(true)).filter(o => o.match(".*_ot_amount$")).map(o => getFieldValue(o)).reduce((sum, o) => sum + Number(o), 0.00))}</span></Col>
                                                                </Row>
                                                            </Flex>
                                                        </div>
                                                    </Card>
                                                </Space>
                                            </Col>
                                            {/* <Col span={1} style={{ borderRight: "2px solid" }}></Col> */}
                                            <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            </Col>
                                        </Row>
                                    }
                                    <Divider style={{ borderBlockStart: "1px solid #F0F0F0" }}></Divider>
                                    <Row style={{ width: "100%" }}>
                                        <Col span={12} >
                                            <div style={{ color: "#0FA958", display: 'flex', justifyContent: 'flex-end', marginRight: 10, fontWeight: "bold" }}>
                                                {`${t("employee.total_income")} ${sumIncome} บาท`}
                                            </div>
                                        </Col>
                                        {/* <Col span={1} style={{ borderRight: "2px solid" }}></Col> */}
                                        <Col span={12} style={{ color: "#FF1F00", display: 'flex', justifyContent: 'flex-end', fontWeight: "bold" }}>
                                            <Space direction="vertical" >
                                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    {`${t("employee.total_deduction")} ${sumDeduct} บาท`}
                                                </div>
                                                <div style={{ color: "#00BA34", display: 'flex', justifyContent: 'flex-end', fontWeight: "bold" }}>
                                                    {`${t("employee.net_income")} ${netIncome} บาท`}
                                                </div>
                                            </Space>
                                        </Col>
                                    </Row>
                                </Flex>
                            )
                        }}
                    </Form.Item>
                </FormAntd>
            </Modal >
        </>
    )
}

export default PaymentModal